<template>
<div>
  <w-perf-analysis-time-info class="title-bar"  :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataLoad" />
  <div class="title-h4 title-bar">서비스 정보</div>
  <w-performance-list name="svcPerfList" :performance-data="performanceList" />
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty } from '@/utils/basic';
import { getIntervalDatetimeParams } from '@/utils/date';
import ServiceAPI from '@/api/performance/service/service';
import WPerformanceList from '@/views/performance/components/PerformanceList';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import { analysisTimeType, defaultAnalysisTimeType } from '@/constants/performance';

export default {
  name: 'WPerformanceServiceAnalysisTable',
  components: {
    WPerformanceList,
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      analysisTimeType,
      checkDatetime: null,
      performanceList: [],
      activeTab: 'serviceInfo',
      timeType: {
        svcPerfList: defaultAnalysisTimeType,
      },
    };
  },
  computed: mapGetters(['selectedNode', 'plotLineDatetime']),
  watch: {
    plotLineDatetime: {
      handler(value) {
        this.checkDatetime = this.plotLineDatetime;
        if (isEmpty(value)) {
          this.performanceList = [];
          return;
        }
        this.loadData();
      },
    },
  },
  methods: {
    /**
     * 서비스 정보(서비스에 포함된 관리대상들의 성능정보)의 데이터를 가져온다.
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      if (this.timeType.svcPerfList === this.analysisTimeType.HIST.value) {
        ServiceAPI.getServiceAnalysisPerformance({
          objId: this.selectedNode.obj.objId,
          baselineDatetime: this.plotLineDatetime,
          managetypeId: 'SVC',
        }).then((response) => {
          if (response.data.success) {
            this.performanceList = response.data.data.snapshotDoc;
          } else {
            this.performanceList = [];
          }
        });
      } else {
        ServiceAPI.getServicePerformance({
          serviceId: this.selectedNode.obj.objId,
          startDatetime: getIntervalDatetimeParams(new Date(), 'minutes', 15),
          endDatetime: new Date().getTime(),
        }).then((response) => {
          if (response.data.success) {
            this.performanceList = response.data.data;
          }
        });
      }
    },
    onTimeTypeChange(value) {
      this.timeType.svcPerfList = value;
      this.loadData();
    },
    onCurrentDataLoad() {
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/service/PerformanceServiceAnalysisTable.vue